import React, { Component } from 'react';
import { withStyles, withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// modules
import clsx from 'clsx';
import { alpha } from '@material-ui/core/styles/colorManipulator';

// ui/ux
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';
// icons
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MapIcon from '@material-ui/icons/Map';

// colors
import green from '@material-ui/core/colors/green';

// GLOBALS
const API_HOST = process.env.REACT_APP_ADMIN_API_HOST; // eslint-disable-line no-undef

const styles = (theme) => ({
  slimDivider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  indent: {
    marginLeft: theme.spacing(2)
  },
  excerpt: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main)
  },
  btnWrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  btnProgress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  btnDisabled: {
    color: theme.palette.text.primary
  },
  panelDetails: {
    display: 'block'
  },
  gridContainer: {
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  },
  gridContainerGutter: {
    marginBottom: theme.spacing(4)
  },
  dangerBtn: {
    '&:hover': {
      borderColor: theme.palette.error.main,
      color: theme.palette.error.main,
      backgroundColor: alpha(theme.palette.error.main, 0.1)
    }
  }
});

class Review extends Component {
  constructor(props) {
    super(props);
    console.log('Review', JSON.stringify({ ...props, classes: null, theme: null, onComplete: null }));
    this.state = {
      processing: false,
      thresholdsByTopic: {}
    };

    this.state.topics = Object.keys(props.mapping);
    for (const topic of this.state.topics) {
      this.state.thresholdsByTopic[topic] = {
        string: 0.2,
        spatial: 0.2,
        disabled: true
      };
    }

    // UI/UX Bindings
    this.submit = this.submit.bind(this);

    this._xhrThresholds = {};
    this._xhrCreate = {};
  }
  componentWillUnmount() {
    this._xhrThresholds.cancel && this._xhrThresholds.cancel();
    this._xhrCreate.cancel && this._xhrCreate.cancel();
  }
  componentDidMount() {
    const { topics } = this.state;
    this._xhrThresholds.cancel && this._xhrThresholds.cancel();
    window.genericPost(`${API_HOST}/admin/v0/topics/thresholds`, topics, this._xhrThresholds, (e, r) => {
      if (e) return console.error(e);

      const tbt = {};
      for (const topic of topics) {
        const et = r[topic];
        if (et) {
          tbt[topic] = {
            ...et,
            disabled: true
          };
        } else {
          tbt[topic] = {
            string: 0.2,
            spatial: 0.2,
            disabled: false
          };
        }
      }

      this.setState({
        thresholdsByTopic: tbt
      });
    });
  }
  renderQuestionAction(question) {
    const { classes } = this.props;
    const am = question.answerMapping;
    if (question.existingQuestion) {
      return (
        <React.Fragment>
          <Divider variant="middle" className={classes.slimDivider} />
          <Typography component="span">
            <MapIcon />
            This question was mapped to an existing question:
          </Typography>

          <Typography component="span" className={classes.excerpt}>
            {question.existingQuestion.display_key}
          </Typography>
          <Box className={classes.indent}>
            <ul>
              {Object.keys(am).map((d) => {
                return (
                  <li key={d}>
                    {d} -&gt;
                    <Typography component="span" className={classes.excerpt}>
                      {` ${am[d]}`}
                    </Typography>
                  </li>
                );
              })}
            </ul>
          </Box>
        </React.Fragment>
      );
    } else {
      const nam = question.newAggMapping;
      return (
        <React.Fragment>
          <Divider variant="middle" className={classes.slimDivider} />
          <Typography>
            <AddCircleOutlineIcon />A new aggregation will be built for this question, of type:{' '}
            <Typography component="span" className={classes.excerpt}>
              {nam.aggType}
            </Typography>
          </Typography>
          <Box className={classes.indent}>
            <ul>
              {nam.mappings.map((d) => {
                return (
                  <li key={d.value}>
                    {d.value} -&gt;
                    <Typography component="span" className={classes.excerpt}>
                      {` ${d.label}`}
                    </Typography>
                  </li>
                );
              })}
            </ul>
          </Box>
        </React.Fragment>
      );
    }
  }

  submit() {
    this.setState({
      processing: true
    });
    const { mapping, selectedForm, musts, scopes } = this.props;
    const { thresholdsByTopic } = this.state;

    this._xhrCreate.cancel && this._xhrCreate.cancel();
    window.genericPost(
      `${API_HOST}/admin/v0/topics/create`,
      {
        thresholdsByTopic,
        mapping,
        form_id: selectedForm.form_id,
        form_struct: selectedForm.form_struct,
        musts,
        scopes: scopes.map((d) => d.scope_id)
      },
      this._xhrCreate,
      (e) => {
        if (e) {
          console.error(e);
          return this.setState({
            processing: false
          });
        }

        this.props.onComplete();
      }
    );
  }
  renderButtons() {
    const { classes } = this.props;
    const { processing } = this.state;
    return (
      <Grid container justifyContent="flex-end" spacing={2}>
        <Grid item>
          <div className={classes.btnWrapper}>
            <Button variant="outlined" color="secondary" onClick={this.submit} disabled={processing} className={clsx(processing && classes.btnDisabled)}>
              Submit
            </Button>
            {processing && <CircularProgress size={24} className={classes.btnProgress} />}
          </div>
        </Grid>
      </Grid>
    );
  }

  // label: [],
  // names: [],
  // opts: [],
  // input_type: null
  renderMapped(question, topic) {
    const { musts } = this.props;
    if (!question.answerMapping) {
      return (
        <Box>
          <ul>
            {question.formQuestion.names.map((d) => (
              <li key={d}>{question.existingQuestion.display_key}</li>
            ))}
          </ul>
        </Box>
      );
    }

    return (
      <Box>
        <ul>
          {Object.keys(question.answerMapping).map((d) => {
            const fqName = question.formQuestion.name;
            const isMust = musts && musts[fqName] && musts[fqName][d] === topic;
            return (
              <li key={d}>
                <Box title={isMust ? 'This key value pair must be present to propagate' : null}>
                  {`${d} : ${question.answerMapping[d]}`}
                  {isMust ? <CheckCircleIcon fontSize="small" /> : null}
                </Box>
              </li>
            );
          })}
        </ul>
      </Box>
    );
  }
  renderNewAggregation(question) {
    return (
      <Box>
        <ul>
          {question.newAggMapping.mappings.map((d) => (
            <li key={d.value}>{`${d.value} : ${d.label}`}</li>
          ))}
        </ul>
      </Box>
    );
  }
  renderAssociation(question, topic) {
    const { theme } = this.props;
    const { existingQuestion, newAggMapping, nameOverride } = question;

    // {
    //   formQuestion: {
    //     labels: ['Have you ever personally attended this clinic?', 'Have you ever personally received services at this clinic?'],
    //     names: ['have_you_ever_personally_attended_this_clinic?', 'have_you_ever_personally_received_services_at_this_clinic?'],
    //     opts: [
    //       {
    //         label: 'Yes',
    //         value: 'yes',
    //         image_url: null
    //       },
    //       {
    //         label: 'No',
    //         value: 'no',
    //         image_url: null
    //       },
    //       {
    //         label: 'Yes',
    //         value: 'yes',
    //         image_url: null
    //       },
    //       {
    //         label: 'No',
    //         value: 'no',
    //         image_url: null
    //       }
    //     ],
    //     input_type: 'SELECT_ONE'
    //   },
    //   answerMapping: {
    //     yes: 'yes',
    //     no: 'no'
    //   },
    //   existingQuestion: {
    //     display_key: 'Have you ever attended this clinic',
    //     input_keys: ['have_you_ever_personally_attended_this_clinic?'],
    //     possible_answers: ['no', 'other', 'unsure', 'yes']
    //   }
    // }

    if (nameOverride) {
      return (
        <React.Fragment>
          <Box
            style={{
              padding: theme.spacing(1),
              backgroundColor: alpha(theme.palette.secondary.main, 0.25)
            }}
          >
            <Typography>Mapped</Typography>
          </Box>
          <Box>
            <ul>
              <li>name</li>
            </ul>
          </Box>
        </React.Fragment>
      );
    } else if (existingQuestion) {
      // Mapped.
      return (
        <React.Fragment>
          <Box
            style={{
              padding: theme.spacing(1),
              backgroundColor: alpha(theme.palette.secondary.main, 0.25)
            }}
          >
            <Typography>Mapped</Typography>
          </Box>
          {this.renderMapped(question, topic)}
        </React.Fragment>
      );
    } else if (existingQuestion === false) {
      // Skipped.
      return (
        <Box
          style={{
            padding: theme.spacing(1),
            backgroundColor: alpha(theme.palette.error.main, 0.25)
          }}
        >
          <Typography>Skipped</Typography>
        </Box>
      );
    } else {
      // New Aggregation.
      return (
        <React.Fragment>
          <Box
            style={{
              padding: theme.spacing(1),
              backgroundColor: alpha(green['500'], 0.25)
            }}
          >
            <Typography>{`Created new aggregation of type "${newAggMapping.aggType}": "${question.newAggMapping.name}"`}</Typography>
          </Box>
          {this.renderNewAggregation(question, topic)}
        </React.Fragment>
      );
    }
  }
  renderSliders(topic) {
    const { thresholdsByTopic } = this.state;
    const tt = thresholdsByTopic[topic];
    if (tt.disabled) {
      return null;
    }
    return (
      <React.Fragment>
        <Typography>{`Place Spatial Threshold: ${tt.spatial}`}</Typography>
        <Slider
          disabled={tt.disabled}
          color="secondary"
          onChange={(_, v) => {
            this.setState({
              thresholdsByTopic: {
                ...thresholdsByTopic,
                [topic]: {
                  ...tt,
                  spatial: v
                }
              }
            });
          }}
          value={tt.spatial}
          valueLabelDisplay="auto"
          step={0.02}
          marks
          min={0.02}
          max={2.0}
        />

        <Typography>{`Place Name String Threshold: ${tt.string}`}</Typography>
        <Slider
          disabled={tt.disabled}
          color="secondary"
          onChange={(_, v) => {
            this.setState({
              thresholdsByTopic: {
                ...thresholdsByTopic,
                [topic]: {
                  ...tt,
                  string: v
                }
              }
            });
          }}
          value={tt.string}
          valueLabelDisplay="auto"
          step={0.1}
          marks
          min={0.1}
          max={1.0}
        />
      </React.Fragment>
    );
  }
  renderTopic(topic) {
    const { classes, mapping } = this.props;
    const { topics } = this.state;
    // {
    //   formQuestion: {
    //     labels: ['Have you ever personally attended this clinic?', 'Have you ever personally received services at this clinic?'],
    //     names: ['have_you_ever_personally_attended_this_clinic?', 'have_you_ever_personally_received_services_at_this_clinic?'],
    //     opts: [
    //       {
    //         label: 'Yes',
    //         value: 'yes',
    //         image_url: null
    //       },
    //       {
    //         label: 'No',
    //         value: 'no',
    //         image_url: null
    //       },
    //       {
    //         label: 'Yes',
    //         value: 'yes',
    //         image_url: null
    //       },
    //       {
    //         label: 'No',
    //         value: 'no',
    //         image_url: null
    //       }
    //     ],
    //     input_type: 'SELECT_ONE'
    //   },
    //   answerMapping: {
    //     yes: 'yes',
    //     no: 'no'
    //   },
    //   existingQuestion: {
    //     display_key: 'Have you ever attended this clinic',
    //     input_keys: ['have_you_ever_personally_attended_this_clinic?'],
    //     possible_answers: ['no', 'other', 'unsure', 'yes']
    //   }
    // }
    return (
      <Accordion key={topic} defaultExpanded={topics.length === 1}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
          <Typography variant="h5">{topic}</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.panelDetails}>
          {this.renderSliders(topic)}
          {mapping[topic].map((q, i) => {
            const fictional = q.formQuestion.input_type === 'STATIC_FICTIONAL';
            return (
              <Grid spacing={2} container direction="row" justifyContent="flex-start" alignItems="flex-start" key={i} className={clsx(classes.gridContainerGutter, classes.gridContainer)}>
                <Grid item xs>
                  <Typography variant="body1">{q.formQuestion.input_type}</Typography>
                  {fictional && <Typography variant="body2">{`"${q.nameOverride}"`}</Typography>}
                  {!fictional && (
                    <React.Fragment>
                      <Typography variant="body2">Labels</Typography>
                      <ul>
                        {q.formQuestion.labels.map((d) => (
                          <li key={d}>{d}</li>
                        ))}
                      </ul>
                      <Typography variant="body2">Names</Typography>
                      <ul>
                        {q.formQuestion.names.map((d) => (
                          <li key={d}>{d}</li>
                        ))}
                      </ul>
                    </React.Fragment>
                  )}
                </Grid>
                <Grid item xs>
                  {this.renderAssociation(q, topic)}
                </Grid>
              </Grid>
            );
          })}
        </AccordionDetails>
      </Accordion>
    );
  }

  render() {
    const { mapping } = this.props;

    const topics = Object.keys(mapping);
    return (
      <React.Fragment>
        <Typography variant="h1">Review</Typography>
        {this.renderButtons()}
        {topics.map((topic) => this.renderTopic(topic, mapping[topic], topics.length))}
        {this.renderButtons()}
      </React.Fragment>
    );
  }
}

Review.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  mapping: PropTypes.object.isRequired,
  selectedForm: PropTypes.object.isRequired,
  musts: PropTypes.object,
  onComplete: PropTypes.func.isRequired,
  scopes: PropTypes.array.isRequired
};

Review.defaultProps = {
  musts: {}
};

export default withTheme(withStyles(styles)(Review));
